import { Moment } from 'moment';
import { StackFrame } from '../../../common/calls/models/StackFrame';
import { TraceType } from '../../../common/enums/TraceType';
import { OperationContext } from '../../../common/operations/enums/OperationContext';
import { OperationType } from '../../../common/operations/enums/OperationType';

export class OperationDetail {
  constructor(
    private readonly id: number,
    private readonly reportId: number,
    private readonly projectId: number,
    private readonly reportTraceType: TraceType | null,
    private readonly type: OperationType,
    private readonly context: OperationContext,
    private readonly algorithms: string[] | null,
    private readonly valueJson: object,
    private readonly firstCallSite: StackFrame | null,
    private readonly timestamp: Moment | null
  ) {}

  getId() {
    return this.id;
  }

  getReportId() {
    return this.reportId;
  }

  getProjectId() {
    return this.projectId;
  }

  getTraceType() {
    return this.reportTraceType;
  }

  getType() {
    return this.type;
  }

  getContext() {
    return this.context;
  }

  getAlgorithms() {
    return this.algorithms ?? [];
  }

  getValueJson() {
    return this.valueJson;
  }

  getFirstCallSite() {
    return this.firstCallSite;
  }

  getTimestamp() {
    return this.timestamp;
  }
}
